import React, { useEffect, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LockOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button, theme, Dropdown, Space } from "antd";
import { Footer } from "antd/es/layout/layout";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { selector } from "../api";
import { authActions, authCRUD } from "../actions/auth";
import { useDispatch } from "react-redux";
import { char, code } from "../utils";
import { Badge } from "rsuite";

const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

function getItems(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

export default function MasterLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  let navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("persist:root");
    navigate("/");
    document.location.reload();
  };

    const handleLock = () => {
      dispatch(authActions.setLock(true));
      dispatch(authActions.setAuth(null));
      const currentPath = location.pathname;
      localStorage.setItem("fromPath", currentPath);
      navigate("/lockscreen", { replace: true });
      document.location.reload();
    };

  const user = selector.User();

  const items = [
    getItems("Profile", "profile", <UserOutlined />, ""),
    getItems(
      <Link className="text-decoration-none" to={"#"} onClick={handleLock}>
        Lock Screen
      </Link>,
      "lock",
      <LockOutlined />,
      ""
    ),
    getItems(
      <Link className="text-decoration-none" to={"#"} onClick={handleLogout}>
        Logout
      </Link>,
      "out",
      <LogoutOutlined />,
      ""
    ),
  ];

  const item = user?.is_student
    ? [
        // STUDENT MENU — ONLY DASHBOARD + IDENTITY
        getItem(
          <Link to={"/home"} className="text-decoration-none">
            Dashboard
          </Link>,
          "home",
          <i className="ri-apps-2-line fs-4" />
        ),
        getItem("Identity", "sub3", <i className="ri-profile-line fs-4" />, [
          getItem(
            <Link to={"/student"} className="text-decoration-none">
              Student
            </Link>,
            "student"
          ),
        ]),
      ]
    : [
        // FULL MENU FOR ADMINS, OPERATORS, ETC
        getItem(
          <Link to={"/home"} className="text-decoration-none">
            Dashboard
          </Link>,
          "home",
          <i className="ri-apps-2-line fs-4" />
        ),
        getItem(
          "Configurations",
          "sub2",
          <i className="ri-settings-4-line fs-4" />,
          [
            getItem(
              <Link to={"/almanac"} className="text-decoration-none">
                Almanac
              </Link>,
              "almanac"
            ),
            getItem(
              <Link to={"/academic"} className="text-decoration-none">
                Academic Year
              </Link>,
              "academic"
            ),
          ]
        ),
        getItem("Identity", "sub3", <i className="ri-profile-line fs-4" />, [
          getItem(
            <Link to={"/student"} className="text-decoration-none">
              Student
            </Link>,
            "student"
          ),
          getItem(
            <Link
              to={"identity"}
              state={{ page: "staff" }}
              className="text-decoration-none"
            >
              Staff
            </Link>,
            "staff"
          ),
        ]),
        getItem("Reports", "sub4", <i className="ri-stack-line fs-4" />, [
          getItem(
            <Link
              to={"/report"}
              state={{ page: "print" }}
              className="text-decoration-none"
            >
              Printed ID
            </Link>,
            "print"
          ),
        ]),
        getItem(
          "Authentication",
          "sub5",
          <i className="ri-door-lock-line fs-4" />,
          [
            getItem(
              <Link to={"/user"} className="text-decoration-none">
                User
              </Link>,
              "user"
            ),
          ]
        ),
      ];


  return (
    <Layout>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ minHeight: "100vh" }}
        width={250}
      >
        {collapsed ? (
          <div className="demo-logo-vertical mb-5 text-center mt-4">
            <span className="h4 text-white fw-bold">ARU</span>
          </div>
        ) : (
          <div className="demo-logo-vertical mb-4 text-center mt-4">
            <span className="h4 text-white fw-bold mt-0">ARDHI UNIVERSITY</span>
            <p className="fw-light h6 text-warning fs-10 fst-italic mt-2">
              {" "}
              ---- weledi na ustawi ----
            </p>
          </div>
        )}
        <Menu
          theme="dark"
          className="fs-5"
          defaultSelectedKeys={["home"]}
          mode="inline"
          items={item}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            backgroundColor: "#d26e29",
            borderBottom: "3px solid #819031",
            color: "#ffffff",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
          <div className="position-absolute top-0 end-0">
            <Dropdown menu={{ items }} className="me-4 cursor-pointer">
              <Space>
                <i className="ri-user-line fs-5" />
                {code.getFirstWord(user.username)}
              </Space>
            </Dropdown>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: "whitesmoke",
          }}
        >
          <Outlet />
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          <p className="fw-bold">
            © {new Date().getFullYear()} &nbsp;{" "}
            <span className="text-primary">ID CARD</span> | &nbsp;
            <span className="h6 fw-bold">ARDHI UNIVERSITY</span>
          </p>{" "}
          <p className="fw-light h6 text-warning fs-12 fst-italic mt-2">
            {" "}
            ---- weledi na ustawi ----
          </p>
        </Footer>
      </Layout>
    </Layout>
  );
}
